
import { CONSTANTS } from "../constants";
export default {
  name: "Home",
  data: () => ({
    BANNER_DETAILS: CONSTANTS.HOME_BANNER_DETAILS,
    REVIEWS: CONSTANTS.REVIEWS,
  }),
};
